<template>
  <div class="ai-history">
    <div v-if="isAuthenticated" class="login">
      <div class="history-container">
        <div class="history-title">
          <span data-track-text="收起翻译历史" aria-label="收起翻译历史" @click="hideHistoryRecord">
            <span class="el-icon-lishijilu icon"></span>
            历史记录
          </span>
          <span v-if="historyList.length" class="close" data-track-text="清空翻译历史" aria-label="清空翻译历史" @click="showConfirm()">
            清空
            <i class="el-icon-guanbi2 icon"></i>
          </span>
        </div>
        <div class="history-list">
          <el-scrollbar class="history-scrollbar">
            <div
              class="history-item"
              v-for="item in historyList"
              :key="item.id"
            >
              <div class="title">
                {{ getLanguageName(item.getFrom()) }}-{{
                  getLanguageName(item.getTo())
                }}
              </div>
              <div class="origin-text">
                {{ item.getTxt() }}
              </div>
              <div class="trans-text">
                {{ item.getTransTxt() }}
              </div>
              <span class="delete-bg">
                <i class="el-icon-delete" data-track-text="删除翻译历史" aria-label="删除翻译历史" @click.stop="showConfirm(item)"></i>
              </span>
            </div>
            <div
              v-if="historyList.length === 0"
              style="text-align: center; margin-top: 60px"
            >
              暂无记录
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <div v-else class="no-login">
      <div class="login-img"></div>
      <div class="login-text">
      <span class="btn" data-track-text="翻译历史登录" aria-label="翻译历史登录" @click="login">登录</span>
        <span>后可保存及查看历史记录</span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  transTextHistoryRequest,
  deleteAllRequest,
  deleteOneRequest,
} from "@/tools/api/translate-api";
import { translateServiceClient } from "@/tools/api/service";
import languages from "../../../language.json";
export default {
  // 组件名称
  name: "TransTextHistory",
  props: {
    userInfo: {
      type: String,
      default: "",
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
  },
  // 变量声明
  data() {
    return {
      historyList: [],
    };
  },
  watch: {
    isAuthenticated(val) {
      if (val) {
        this.getHistory();
      } else {
        this.historyList = [];
      }
    },
  },
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  mounted() {
    if (this.isAuthenticated) {
      this.getHistory();
    }
    console.log(
      22,
      translateServiceClient,
      translateServiceClient.transTextHistory
    );
  },
  // 方法
  methods: {
    hideHistoryRecord() {
      console.log(111);
      this.$emit("hideHistoryRecord");
    },
    getLanguageName(val) {
      return languages.find((item) => item.value === val).label;
    },
    getHistoryMessage(item) {
      this.$parent.$refs.aiChat.getHistoryMessage(item);
      this.$emit("gotoPath", "AITranslate");
    },
    setDefaultChat() {
      this.$emit("gotoPath", "AITranslate");
    },
    getHistory() {
      let request = transTextHistoryRequest;
      // request.setDocId(id);
      console.log(666, translateServiceClient);
      const TOKEN_KEY = "token";
      translateServiceClient
        .transTextHistory(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.historyList = res.getTranstexthistoryList();
          console.log(777, this.historyList);
        });
      // this.$http.get("/chatApi/v1/chat/history").then((res) => {
      //   this.historyList = res.data.data || [];
      // });
    },
    login() {
      console.log(3453);
      this.$emit("getUserStatus");
    },
    showConfirm(item) {
      this.$confirm("删除后无法恢复，是否继续删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const request = item ? deleteOneRequest : deleteAllRequest;
          const TOKEN_KEY = "token";
          if (item) {
            request.setId(item.getId());
            translateServiceClient
              .deleteOne(request, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
              .then((res) => {
                this.$message.success("删除成功");
                this.getHistory();
              });
          } else {
            translateServiceClient
              .deleteAll(request, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
              .then((res) => {
                this.$message.success("删除成功");
                this.getHistory();
              });
          }
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.ai-history {
  background: #fff;
  padding: 36px 20px 0;
  width: 270px;
  margin-top: -52px;
  border-left: 1px solid #eceeef;
  z-index: 9;
  .login {
    height: 100%;
  }
  .history-container {
    overflow: auto;
    height: calc(100% - 6px);
    font-size: 14px;
    .history-title {
      font-size: 16px;
      color: #333333;
      position: relative;
      span {
        cursor: pointer;
      }
      .icon {
        font-size: 18px;
        vertical-align: bottom;
      }
      .close {
        cursor: pointer;
        position: absolute;
        right: 0;
        font-size: 14px;
        color: #666666;
      }
    }
    .history-list {
      padding-top: 15px;
      height: calc(100% - 100px);
      overflow: hidden;
      .history-scrollbar {
        height: 100%;
        /deep/.el-scrollbar__wrap {
          overflow-x: hidden;
        }
        .history-item {
          background: rgba(241, 242, 243, 0.35);
          margin-top: 12px;
          border-radius: 6px;
          padding-left: 20px;
          line-height: 34px;
          position: relative;
          font-size: 14px;
          .title {
            color: #a6a6a6;
          }
          .origin-text,
          .trans-text {
            display: -webkit-box; /* 使用弹性盒子布局 */
            -webkit-box-orient: vertical; /* 垂直方向排列 */
            -webkit-line-clamp: 2; /* 限制显示 2 行 */
            overflow: hidden; /* 超出部分隐藏 */
            text-overflow: ellipsis; /* 超出部分显示... */
          }
          .origin-text {
            color: #333333;
          }
          .trans-text {
            color: #666666;
          }
          &:hover {
            background: #f1f2f3;
            .delete-bg {
              display: inline-block;
              color: #737373;
            }
          }
          .delete-bg {
            position: absolute;
            right: 12px;
            top: 4px;
            cursor: pointer;
            display: none;
          }
        }
      }
    }
  }
  .no-login {
    width: 116px;
    margin: 150px auto 0;
    .login-img {
      width: 95px;
      height: 88px;
      background: url(../../assets/chat/login.png) center no-repeat;
      background-size: contain;
    }
    .login-text {
      font-size: 16px;
      color: #737373;
      line-height: 28px;
      margin-top: 10px;
      .btn {
        color: var(--primary);
        text-decoration-line: underline;
        cursor: pointer;
      }
    }
  }
}
</style>
